import { useSelector } from 'react-redux'
import categoriesSlice from './categoriesSlice'

export const useGroups = () => {
  const reducerState = useSelector((state) => state)
  return reducerState
}

export const { getAllCategories } = categoriesSlice.actions

export default categoriesSlice.reducer
